import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import { format } from 'date-fns'
import React from 'react'
import { useSelector } from 'react-redux'
import { useActions } from '../../../../actions'
import * as BookingActions from '../../../../actions/bookingInfo'
import * as FilterActions from '../../../../actions/filter'
import { useMediaQuery } from '@material-ui/core'

// const venuesMock = [
//   {
//     value: 'All venues',
//     label: 'All venues'
//   },
//   {
//     value: 'The greatest show',
//     label: 'TGS'
//   },
//   {
//     value: 'Spiderman: Homing coming',
//     label: 'SPI'
//   },
//   {
//     value: 'London Clock',
//     label: 'LC'
//   },
//   {
//     value: 'Kamppi Mangoo',
//     label: 'KM'
//   }
// ]

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  textField: {},
  dense: {
    marginTop: theme.spacing(2)
  },
  menu: {
    width: 200
  }
}))

export const VenuesDropdown = () => {
  const matches = useMediaQuery(theme => theme.breakpoints.down('md'))
  //console.log(window.dashboardVenueList);
  // const [venues, setVenues] = useState(venuesMock)
  //const venues = useSelector(state => state.bookingInfo.venues)
  const venues = useSelector(state => state.bookingInfo.venues)

  // const [venue, setVenue] = useState('')
  const venue = useSelector(state => state.filter.selectedVenue)
  //console.log(venue);
  const filterActions = useActions(FilterActions)
  const bookingActions = useActions(BookingActions)
  const from = useSelector(state => state.filter.from)
  const to = useSelector(state => state.filter.to)

  const venueText = useSelector(state => state.language.text.venue)

  const classes = useStyles()
  return (
    <TextField
      select
      className={classes.textField}
      value={venue}
      onChange={e => {
        filterActions.setSelectedVenue(e.target.value)
        bookingActions.fetchBookingInfo(
          e.target.value,
          format(from, 'yyyy-MM-dd'),
          format(to, 'yyyy-MM-dd')
        )
      }}
      SelectProps={{
        native: matches,
        MenuProps: {
          className: classes.menu
        }
      }}
      label={venueText}
      margin="normal"
      variant="outlined"
      fullWidth>
      {venues.map(option =>
        !matches ? (
          <MenuItem key={option.vid} value={option.vid}>
            {option.name}
          </MenuItem>
        ) : (
          <option key={option.vid} value={option.vid}>
            {option.name}
          </option>
        )
      )}
    </TextField>
  )
}

export default VenuesDropdown
